import { render } from "./RightBar.vue?vue&type=template&id=e52a4df2"
import script from "./RightBar.vue?vue&type=script&lang=js"
export * from "./RightBar.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/RightBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e52a4df2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e52a4df2', __exports__)) {
    api.reload('e52a4df2', __exports__)
  }
  
  module.hot.accept("./RightBar.vue?vue&type=template&id=e52a4df2", () => {
    api.rerender('e52a4df2', render)
  })

}


export default __exports__